const STEP_SELECTOR = '.wp-block-fc-block-fc-flowchart-step';
const FLOWCHART_SELECTOR = '.wp-block-fc-block-fc-flowchart';
const ARROW_LAYER_SELECTOR = '.fc-flowchart__arrows';
const ARROW_SIZE = 34;
const PARALLEL_ARROW_SPACING = 32;
const DESKTOP_MEDIA_QUERY = '(min-width: 650px)';
const CONNECTOR_TYPES = ['forward', 'return-above', 'return-below', 'double'];

function getFlowchartColumns(root) {
	if (root.classList.contains('fc-flowchart--cols-1')) {
		return 1;
	}

	if (root.classList.contains('fc-flowchart--cols-2')) {
		return 2;
	}

	return 3;
}

function applyStepLayout(root, steps) {
	const columns = getFlowchartColumns(root);
	const isDesktop = window.matchMedia(DESKTOP_MEDIA_QUERY).matches;

	steps.forEach((step, index) => {
		step.style.gridColumn = '';
		step.style.gridRow = '';

		if (!isDesktop || columns === 1) {
			return;
		}

		const row = Math.floor(index / columns) + 1;
		const columnOffset = index % columns;
		const column = row % 2 === 1 ? columnOffset + 1 : columns - columnOffset;

		step.style.gridColumn = String(column);
		step.style.gridRow = String(row);
	});
}

function getArrowPosition(step, nextStep, containerRect) {
	const stepRect = step.getBoundingClientRect();
	const nextRect = nextStep.getBoundingClientRect();
	const sameRow = Math.abs(stepRect.top - nextRect.top) < 8;

	let direction = 'down';
	let arrowLeft = 0;
	let arrowTop = 0;

	if (sameRow && nextRect.left > stepRect.left) {
		direction = 'right';
		arrowLeft = (stepRect.right + nextRect.left) / 2 - containerRect.left - ARROW_SIZE / 2;
		arrowTop = (stepRect.top + stepRect.bottom) / 2 - containerRect.top - ARROW_SIZE / 2;
	} else if (sameRow && nextRect.left < stepRect.left) {
		direction = 'left';
		arrowLeft = (stepRect.left + nextRect.right) / 2 - containerRect.left - ARROW_SIZE / 2;
		arrowTop = (stepRect.top + stepRect.bottom) / 2 - containerRect.top - ARROW_SIZE / 2;
	} else {
		direction = 'down';
		arrowLeft = (stepRect.left + stepRect.right) / 2 - containerRect.left - ARROW_SIZE / 2;
		arrowTop = (stepRect.bottom + nextRect.top) / 2 - containerRect.top - ARROW_SIZE / 2;
	}

	return {
		direction,
		arrowLeft,
		arrowTop,
	};
}

function getReverseDirection(direction) {
	if (direction === 'right') {
		return 'left';
	}

	if (direction === 'left') {
		return 'right';
	}

	return 'up';
}

function appendArrow(arrowLayer, direction, arrowLeft, arrowTop, modifier = '') {
	const arrow = document.createElement('span');
	arrow.className = `fc-flowchart__arrow fc-flowchart__arrow--${direction}${modifier ? ` ${modifier}` : ''}`;
	arrow.style.left = `${Math.round(arrowLeft)}px`;
	arrow.style.top = `${Math.round(arrowTop)}px`;
	arrowLayer.appendChild(arrow);
}

function appendConnector(arrowLayer, step, direction, arrowLeft, arrowTop) {
	const requestedType = step.dataset.fcFlowchartConnector || 'forward';
	const connectorType = CONNECTOR_TYPES.includes(requestedType) ? requestedType : 'forward';
	const doubleArrowClass = connectorType === 'double' ? 'fc-flowchart__arrow--double' : '';
	let forwardLeft = arrowLeft;
	let forwardTop = arrowTop;
	let returnLeft = arrowLeft;
	let returnTop = arrowTop;

	if (connectorType === 'return-above' || connectorType === 'return-below') {
		const returnOffset = (connectorType === 'return-above' ? -1 : 1) * (PARALLEL_ARROW_SPACING / 2);

		if (direction === 'down') {
			returnLeft += returnOffset;
			forwardLeft -= returnOffset;
		} else {
			returnTop += returnOffset;
			forwardTop -= returnOffset;
		}
	}

	appendArrow(arrowLayer, direction, forwardLeft, forwardTop, doubleArrowClass);

	if (connectorType === 'forward') {
		return;
	}

	appendArrow(
		arrowLayer,
		getReverseDirection(direction),
		returnLeft,
		returnTop,
		`fc-flowchart__arrow--return ${doubleArrowClass}`.trim()
	);
}

function positionFlowchartArrows(root) {
	const steps = Array.from(root.querySelectorAll(STEP_SELECTOR));
	const arrowLayer = root.querySelector(ARROW_LAYER_SELECTOR);
	if (!arrowLayer) {
		return;
	}

	applyStepLayout(root, steps);
	const containerRect = root.getBoundingClientRect();

	arrowLayer.innerHTML = '';

	steps.forEach((step, index) => {
		const nextStep = steps[index + 1] || null;
		if (!nextStep) {
			return;
		}

		const { direction, arrowLeft, arrowTop } = getArrowPosition(step, nextStep, containerRect);
		appendConnector(arrowLayer, step, direction, arrowLeft, arrowTop);
	});
}

function initFlowchartArrows() {
	const flowcharts = Array.from(document.querySelectorAll(FLOWCHART_SELECTOR));
	if (flowcharts.length === 0) {
		return;
	}

	const rerender = () => {
		flowcharts.forEach((flowchart) => positionFlowchartArrows(flowchart));
	};

	rerender();
	window.addEventListener('load', rerender);
	window.addEventListener('resize', rerender);

	if (window.ResizeObserver) {
		const observer = new ResizeObserver(rerender);
		flowcharts.forEach((flowchart) => {
			observer.observe(flowchart);
			flowchart.querySelectorAll(STEP_SELECTOR).forEach((step) => observer.observe(step));
		});
	}
}

initFlowchartArrows();
